import { useEffect } from "react";

const usePreloadImages = (imageUrls: string[]) => {
  useEffect(() => {
    if (!imageUrls?.length) return;

    const preload = () => {
      imageUrls.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(preload);
    } else {
      setTimeout(preload, 1500);
    }
  }, [imageUrls]);
};

export default usePreloadImages;
